'use client';

import {
  GeneralError as GeneralErrorTemplate,
  type GeneralErrorProps
} from '@coolblue-development/next-error/client';
import {
  CoolblueLogo,
  Header,
  HeaderLogoContainer,
  LogoLink
} from '@coolblue-development/next-header/client';
import { getLogger } from '@coolblue-development/react-logging';
import { useEffect } from 'react';

export default function Error(props: GeneralErrorProps) {
  useEffect(() => {
    getLogger().error('GeneralError component rendered due to an uncaught exception.', props.error);
  }, [props]);

  return (
    <>
      <Header>
        <LogoLink link='/'>
          <HeaderLogoContainer>
            <CoolblueLogo />
          </HeaderLogoContainer>
        </LogoLink>
      </Header>
      <GeneralErrorTemplate {...props} />
    </>
  );
}
